import React from 'react'
import Logo from '../logo/Logo'
import SearchButton from '../search-button/SearchButton'
import HamburgerMenu from '../hamburger-menu/HamburgerMenu'
import { styled } from '@mui/material/styles'

export interface IOwnProps {
  className?: string
}

export type IProps = IOwnProps

const Header: React.FC<IProps> = (props) => {
  const {
    children,
    className,
  } = props

  return (
    <header className={className}>
      <HamburgerMenu />
      {children}
      <SearchButton />
      <Logo />
    </header>
  )
}

export default styled(Header)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '12px 0',
  borderBottom: '1px solid rgba(212, 212, 211, 0.63)',
  color: '#d4d4d3',
  fontSize: 15,
  backgroundColor: theme.palette.backgroundColor.main,
  zIndex: 10,
}))
